module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-44.6bdc5636.png";